import { useSessionTracker } from '@/hooks/useSessionTracker';

const SessionTracker = () => {
  useSessionTracker();
  return null;
};

export default SessionTracker;
